import { getAuth, onAuthStateChanged, type User } from "firebase/auth";
import { useEffect, useState } from "react";

export function useFirebaseUser() {
    const [user, setUser] = useState<User>();

    useEffect(() => {
        // console.log("Signed in");
        const unsubscribe = onAuthStateChanged(getAuth(), async (user) => {
            if (user) {
                setUser(user);
            } 
        });
        return unsubscribe;
    }, []);

    return user;
}